import { VOCategory, VOGalleryList, VOGalleryMedia } from "../../model/DataStructure.js";

export interface ArrowState {
    left: "none" | "normal" | "skip";
    right: "none" | "normal" | "skip";
    index: number;
    total: number;
}

export abstract class AbstractContentView {

    public onRequestGallery = e5.Signal.create<[VOGalleryList, number, number]>();
    public onSelectEntry = e5.Signal.create<[string]>();
    public onChangeShowArrows = e5.Signal.create<[ArrowState]>();
    public onActiveChange = e5.Signal.create<[boolean]>();
    public onBlurChange = e5.Signal.create<[boolean]>();
    //VOGalleryList, galleryIndex, mediaIndex
    public onCloseGallery = e5.Signal.create<[VOGalleryList, number, number]>();
    public onClosedEnd = e5.Signal.create();

    public element: HTMLDivElement;

    private _showArrows: ArrowState = {
        left: "none",
        right: "none",
        index: 0,
        total: 0
    };

    constructor() {
        this.element = document.createElement("div");
        this.element.className = "abstract-content-view active";

        // this.onClosedEnd.add(() => this.reset());
    }

    public get showArrows(): ArrowState {
        return this._showArrows;
    }

    public set showArrows(showArrows: ArrowState) {
        // if (this._showArrows === showArrows)
        //     return;
        this._showArrows = showArrows;
        this.onChangeShowArrows.dispatch(this._showArrows);
    }

    public get active(): boolean {
        return this.element.classList.contains("active");
    }

    public set active(active: boolean) {
        if (this.active === active) {
            return;
        }
        this.element.classList.toggle("active", active);
        this.onActiveChange.dispatch(active);
    }

    public get blurred(): boolean {
        return this.element.classList.contains("blurred");
    }

    public set blurred(active: boolean) {
        if (this.blurred === active) {
            return;
        }
        this.element.classList.toggle("blurred", active);
        this.onBlurChange.dispatch(active);
    }

    public next(): void {

    }

    public prev(): void {

    }

    public abstract open(): void;

    public abstract create(category: VOCategory): Promise<any>;

    public abstract handleClickClose(): boolean;

    public abstract reset(): void;
}